import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { ShopCover, ShopMeta } from './ShopElements';

export const ProductCard = ({ product, shop, featured = false }) => {
  const { t, lang, link } = shop;
  const copy = product[lang];
  return <article className={`shop-card ${featured ? 'shop-featured-card' : ''}`} data-testid={`shop-card-${product.id}`}>
    <Link to={link(product.id)} className="shop-cover-link" tabIndex={-1} aria-hidden="true" data-testid={`shop-cover-link-${product.id}`}>
      <ShopCover product={product} t={t} lang={lang}/>
    </Link>
    <div className="shop-card-body">
      <div className="shop-card-top" data-testid={`shop-label-${product.id}`}>
        <span>{featured ? t.pdf : `Setup ${product.number}`}</span>
        {!product.price_chf && <span className="shop-free">{t.free}</span>}
      </div>
      <h3 data-testid={`shop-name-${product.id}`}><Link to={link(product.id)} data-testid={`shop-product-${product.id}`}>{copy.name}</Link></h3>
      <p className="shop-card-description" data-testid={`shop-description-${product.id}`}>{featured ? copy.description : copy.subtitle}</p>
      <ShopMeta product={product} t={t}/>
      <p className="shop-level" data-testid={`shop-level-${product.id}`}>{t.levels[product.level]}</p>
      <div className="shop-card-bottom">
        <strong className="shop-price" data-testid={`shop-price-${product.id}`}>{product.price_chf ? <>{product.price_chf}<small> CHF</small></> : t.free}</strong>
        <Link to={link(product.id)} className="shop-discover" data-testid={`shop-discover-${product.id}`} aria-label={`${t.detail} — ${copy.name}`}>
          {t.detail}<ArrowUpRight size={17} aria-hidden="true"/>
        </Link>
      </div>
      <span className="shop-card-status" data-testid={`shop-status-${product.id}`}>{shop.salesEnabled && product.available_languages?.includes(lang) ? t.ready : t.available}</span>
    </div>
  </article>;
};